import {
  AddMembersDocument,
  AddMembersMutation,
  AddMembersMutationVariables,
  TeamMembershipFragmentDoc,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useAddMembers = () => {
  const [mutation, { loading }] = useMutation(AddMembersDocument, {
    extractorFn: (data: AddMembersMutation) => data.teamsMutations.bulkUpsertTeamsMembership,
  })

  const addMembers = (variables: AddMembersMutationVariables) => {
    return mutation({
      variables,
      update: (cache, { data }) => {
        try {
          const newMemberships = data?.teamsMutations.bulkUpsertTeamsMembership?.memberships
          if (!newMemberships?.length) return

          const teamCacheId = cache.identify({ __typename: 'TeamsTeam', id: variables.teamId })
          if (!teamCacheId) return

          cache.modify({
            id: teamCacheId,
            fields: {
              memberships(existingMemberships = [], { readField }) {
                const existingMembershipsArray = Array.isArray(existingMemberships)
                  ? existingMemberships.filter(Boolean)
                  : [existingMemberships].filter(Boolean)

                const existingMembershipIds = new Set(
                  existingMembershipsArray.map((item: { __ref: string }) => readField('id', item))
                )

                const newMembershipRefs = newMemberships
                  .filter((item) => item && !existingMembershipIds.has(item.id))
                  .map((item) =>
                    cache.writeFragment({
                      data: item,
                      fragment: TeamMembershipFragmentDoc,
                      fragmentName: 'TeamMembership',
                    })
                  )
                  .filter(Boolean)

                return [...existingMembershipsArray, ...newMembershipRefs]
              },
            },
          })
        } catch {
          return
        }
      },
    })
  }

  return { loading, addMembers }
}

export default useAddMembers
